import React from 'react';
import ReactDOM from 'react-dom/client';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import App from './App.js';
import About from './Routes/About.js';
import Contact from './Routes/Contact.js';
import Gallery from './Routes/Gallery.js';
import Mint from './Routes/Mint.js';
import Error from './Routes/Error.js';
import { 
  BrowserRouter,
  Routes,
  Route 
} from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));

const firebaseConfig = {
  apiKey: "AIzaSyCGMXTl3tzuNkRzS9syRuZig-r6E4TZLe4",
  authDomain: "societal-labs-web-app.firebaseapp.com",
  projectId: "societal-labs-web-app",
  storageBucket: "societal-labs-web-app.appspot.com",
  messagingSenderId: "716716017312",
  appId: "1:716716017312:web:22e7244c873e2da3c1ebc5",
  measurementId: "G-0DP7WPQJ8V"
};

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
const analytics = getAnalytics(app);

root.render(
    <BrowserRouter >
      <Routes>
        <Route path='/' element={<App />}></Route>
        <Route path='About' element={<About />}></Route>
        <Route path='Contact' element={<Contact />}></Route>
        <Route path='Gallery' element={<Gallery />}></Route>
        <Route path='Mint' element={<Mint />}></Route>
        <Route path='*' element={<Error />}></Route>
      </Routes>
    </BrowserRouter>
);
